import styled from "@xstyled/styled-components";

import { FieldContainer } from "./FieldContainer";
import { Input } from "./Input";
import { ErrorText } from "./ErrorText";

import { Alert, Label } from "@otta/design";
export interface IInputFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name: string;
  placeholder?: string;
  error?: string;
  required?: boolean;
  warning?: string;
  type?:
    | "button"
    | "checkbox"
    | "color"
    | "date"
    | "datetime-local"
    | "email"
    | "file"
    | "hidden"
    | "image"
    | "month"
    | "number"
    | "password"
    | "radio"
    | "range"
    | "reset"
    | "search"
    | "submit"
    | "tel"
    | "text"
    | "time"
    | "url"
    | "week";
}

const LabelContainer = styled.div`
  display: flex;
  gap: sm;
`;

/**
 * ```ts
 *
 * import { InputField } from '@otta/design'
 *
 * ```
 */

export function InputField({
  label,
  name,
  type,
  error,
  placeholder,
  required,
  warning,
  ...props
}: IInputFieldProps): React.ReactElement {
  return (
    <FieldContainer>
      <LabelContainer>
        {label && <Label htmlFor={name}>{label}</Label>}
      </LabelContainer>
      <Alert level="information">{warning}</Alert>
      <Input
        id={name}
        name={name}
        type={type}
        placeholder={placeholder}
        error={!!error}
        {...props}
      />
      {error && <ErrorText>{error}</ErrorText>}
    </FieldContainer>
  );
}
